import txBase, {TO_SAVE_BASE, KEY} from '../../../vuex/tx-base';
import {registerModule} from '../../../vuex/helpers/vuex-pathify-register-module';
import {sync, make} from 'vuex-pathify'

import deepmerge from "deepmerge";

const STORE_NAMESPACE = 'html-template';

function isSet(obj, key) {
    return obj && obj[key] !== typeof undefined
}

const initState = () => {
    let mapData = window[KEY];

    let firstCity = isSet(mapData, 'firstCity') ? mapData.firstCity : "Stockholm";
    let secondCity = isSet(mapData, 'secondCity') ? mapData.secondCity : "Göteborg";

    return {
        center: mapData?.center?.map(number => Number) || [62.101002060735084, 13.690978983216212],
        zoom: mapData?.zoom || 10,
        firstCity,
        secondCity,
        lang: mapData?.lang || "sw",

        country: mapData?.country || 'Sverige',
        city: mapData?.city || 'Stockholm',
    }
}

let vuexModule = {};
vuexModule.state = initState();

vuexModule.mutations = {
    ...make.mutations(vuexModule.state)
}

const EXCLUDE_FROM_SAVE = [];

let SAVE_PARAMS = [
    ...TO_SAVE_BASE,
    ...Object.keys(vuexModule.state).filter(item => !!EXCLUDE_FROM_SAVE.findIndex(exclude => item === exclude))
]

let extendedModule = deepmerge(txBase, vuexModule);

function members() {
    const {state} = extendedModule;
    let computed = {};
    for (let [key, value] of Object.entries(state)) {
        computed[key] = sync(`${STORE_NAMESPACE}/${key}`)
    }

    computed.toSaveParams = function () {
        let toSaveParams = {};
        for (let key of SAVE_PARAMS) {
            toSaveParams[key] = this[key]
        }
        return toSaveParams
    };

    return {
        computed,
    }
}


export default HtmlTemplateModule => {
    return registerModule(STORE_NAMESPACE, extendedModule, members);
}